import React, { PureComponent } from 'react';
import { __ } from 'i18n/index';

export default class MatchReportTypeText extends PureComponent {

	render() {
		const { report } = this.props;
		if(report === WIN_MATCH) {
			return <span className='win text-success'>{__('Won')}</span>;
		}
		if(report === LOSE_MATCH) {
			return <span className='lose text-info'>{__('Lost')}</span>;
		}
		if(report === DISPUTE_MATCH) {

			return <span className='dispute text-danger'>{__('Dispute')}</span>;
		}
		if(report === CANCEL_MATCH) {
			return <span className='cancel text-danger'>{__('Cancelled')}</span>;
		}
		if(report === null) {
			return <span className='no_report'>{__('No Report')}</span>;
		}
		return <span className='no_report'>{__('Unknown')}</span>;
	}
}